import Constants from '../../../constants/Constants';
import {fabric} from 'fabric';

const startDrawing = (canvas: fabric.Canvas, setAnnotationExists: (annotationExists: boolean) => void): void => {
   canvas.isDrawingMode = true;

   canvas.on('path:created', (event: any) => {
      const path = event.path as fabric.Path;
      path.hasControls = false;
      path.name = Constants.annotation.shape.freehand;
      path.hasRotatingPoint = false;
      path.fill = Constants.annotation.transparentColor;
      setAnnotationExists(true);
   });
};

export default {
   startDrawing
};
